import React from 'react';
import './PrimeDetails.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { 
  FaFileInvoice, 
  FaChartBar, 
  FaCreditCard, 
  FaBox, 
  FaFileAlt, 
  FaUniversity, 
  FaSitemap, 
  FaTags, 
  FaUser,
  FaUsers,
  FaServer,
  FaCloud,
  FaCheckCircle,
  FaArrowRight
} from 'react-icons/fa';

const PrimeDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = (path) => location.pathname === path;

  const editions = [
    {
      icon: <FaUser />,
      title: "TallyPrime Silver",
      badge: "Single User",
      color: "#717a88ff",
      description: "Designed for a single person working on one computer at a time. Perfect for small businesses, freelancers, or startups where one person manages the accounts.",
      useCases: ["Solo accountant or business owner", "One computer setup", "Standalone PC — no network needed"],
      img: "/images/silver.png",
      route: "/TallyPrimeServer"
    },
    {
      icon: <FaUsers />,
      title: "TallyPrime Gold",
      badge: "Multi User",
      color: "#c07c06ff",
      description: "Allows unlimited users to work simultaneously on the same data over a Local Area Network (LAN). Best for growing businesses where multiple employees need access at the same time.",
      useCases: ["Multiple staff working together", "Office network (LAN) setup", "Accountant + Owner + Manager — all at once"],
      img: "/images/GOLD.png",
      route: "/TallyPrimeServer"
    },
    {
      icon: <FaServer />,
      title: "TallyPrime Server",
      badge: "Enterprise",
      color: "#6192a1ff",
      description: "An enterprise-grade product built for high-performance, concurrent operations. It optimizes large data handling and is used alongside TallyPrime Gold in large organizations.",
      useCases: ["Large businesses with heavy data", "High-speed concurrent transactions", "IT-managed server infrastructure"],
      img: "/images/SERVER.png",
      route: "/TallyPrimeServer"
    },
    {
      icon: <FaCloud />,
      title: "TallyPrime on Cloud",
      badge: "Anywhere Access",
      color: "#2c2e31ff",
      description: "Access TallyPrime from anywhere in the world — on any device, any browser. No physical server needed. Ideal for businesses with remote teams or multiple branches.",
      useCases: ["Work from home or travel", "Multiple branch access", "No hardware investment required"],
      img: "/images/cloud.png",
      route: "/TallyAws"
    }
  ];

  return (
    <div className="prime-details-page">
      <div className="prime-details-container">

        <main className="prime-content">

          {/* ── Hero: What is TallyPrime ── */}
          <section className="overview-hero-section">
            <div className="overview-hero-text">
              <div className="overview-badge">Product Overview</div>
              <h1>What is TallyPrime?</h1>
              <p className="overview-lead">
                TallyPrime is India's most trusted business management software. In simple terms — it's a tool that helps businesses 
                manage their <strong>accounts, stock, invoices, GST, and finances</strong>, all in one place.
              </p>
              <p className="overview-sub">
                Whether you run a small shop or a large enterprise, TallyPrime handles your day-to-day financial tasks 
                so you can focus on growing your business. Trusted by over <strong>7 million businesses</strong> across India.
              </p>
              <div className="overview-highlights">
                {["GST Filing & e-Invoicing", "Stock & Inventory", "Payroll Management", "Banking & Reconciliation", "Multi-Branch Support", "Real-time Reports"].map(h => (
                  <span key={h} className="highlight-chip"><FaCheckCircle /> {h}</span>
                ))}
              </div>
              <button className="overview-cta-btn" onClick={() => navigate('/contact')}>
                Get a Free Consultation <FaArrowRight />
              </button>
            </div>
            <div className="overview-hero-visual">
              <img src="/images/tally-cover.png" alt="TallyPrime Overview" className="overview-hero-img" />
            </div>
          </section>

          {/* ── Editions: Horizontal 4-col ── */}
          <section className="editions-section">
            <div className="section-heading centered">
              <h2>Which Edition is Right for You?</h2>
              <p>TallyPrime comes in different editions based on how many users need access and the scale of your operations.</p>
            </div>

            <div className="edition-cards">
              {editions.map((ed) => (
                <div className="edition-card" key={ed.title}>
                  <div className="edition-img-wrap">
                    <img src={ed.img} alt={ed.title} className="edition-product-img" />
                  </div>
                  <div className="edition-icon" style={{ color: ed.color, background: `${ed.color}15` }}>
                    {ed.icon}
                  </div>
                  <span className="edition-badge" style={{ color: ed.color, borderColor: `${ed.color}40`, background: `${ed.color}10` }}>{ed.badge}</span>
                  <h3 style={{ color: ed.color }}>{ed.title}</h3>
                  <p className="edition-desc">{ed.description}</p>
                  <ul className="edition-usecases">
                    {ed.useCases.map(uc => (
                      <li key={uc}><FaCheckCircle style={{ color: ed.color }} /> {uc}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </section>

        </main>
      </div>
    </div>
  );
};

export default PrimeDetails;

